import ImgSwitcher from '@/js/components/imgSwitcher'
import { setInnerScroll, getAgentType, authModal, createResvButtons } from "@/js/components/common"
import tripAdvHtml from "@/html/trip-adv.html"
import cancelPolicyHtml from "@/html/cancel-policy.html"
import Modal from '@/js/components/modal'

const main = () => {
    if (!document.querySelector('#page-restaurant')) return false;

    const modal = new Modal()
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    //const ta_id = document.querySelector('meta[name="ta_id"]').getAttribute('content')

    setInnerScroll()

    $('.sec-special-menu .menu-toggle').on('click', e => {
        let targetSection = $(e.currentTarget).closest('section')
        if (targetSection.hasClass('open')) {
            targetSection.removeClass('open')
        } else {
            targetSection.addClass('open')
        }
    })

    // Androidの場合は地図アプリ用リンク変更
    if (!getAgentType().match(/^i/)) {
        let latlng = $('#access .link-gmap').attr('href').replace(/^.*?daddr=([\d\.]+,[\d\.]+)$/, "$1")
        $('#access .link-gmap').attr('href', `https://maps.google.com/maps?daddr=${latlng}`)
    }

    let isPc = false
    if (document.body.clientWidth > 640) {
        isPc = true
    }

    const imgSwitcher = new ImgSwitcher($('#slide'),
        {
            mainClass: 'pickup',
            mainInnerClass: 'pickup-items',
            thumbClass: 'thumbnail ul',
            touch: !isPc,
            swipe: !isPc,
            autoChange: isPc,
            term: 4500,
            changeSpeed: isPc ? 1000 : 200,
            changeMode: isPc ? 'fade' : 'slide',
            hoverChangeStop: false,
            /*
            imgChangeFunc: num => {
                imgSwitcher.data.targetObj.find('.thumbnail ul').children()
                .removeClass('active')
                .eq(num).addClass('active')
            }
            */
        })
    // imgSwitcher.data.targetObj.find('.thumbnail ul').children().first().addClass('active')

    /*
    if(ta_id){
        const ta_key = "8ba87bd1f8e34f908eb5f985217b1686"
        const ta_url = "http://api.tripadvisor.com/api/partner/2.0/location"
     
        $.ajax({
            url: `${ta_url}/${ta_id}`,
            type: 'GET',
            data: {
                key: ta_key,
                lang: "ja",
            },
            dataType: 'json',
        })
        .done(resp => {
            let dom = $(tripAdvHtml)
            dom.find('.rating img').attr('src', resp.rating_image_url)
            dom.find('.reviews a').attr('href', resp.web_url).text(`${resp.num_reviews} Reviews`)
     
            $('.sec-tripAdvisor').append(dom.html())
        })
    }
    */

    $('.btn-cancel-policy').on('click', () => {
        modal.setHtml(cancelPolicyHtml)
        modal.show()
        return false
    })

    $('.reserve-buttons .button.approval').on('click', async (e) => {
        e.preventDefault()
        const stage = $(e.currentTarget).attr('data-stage')
        const encrypt = $(e.currentTarget).attr('data-encrypt')
        let resp = await authModal(stage, { token, encrypt })
            .catch((e) => {
                throw e;
            })
        if (resp.success) {
            sessionStorage.setItem(`resv_${stage}_key`, resp.password);
            $('.reserve-buttons .button.approval').each((i, obj) => {
                const parent = $(obj).parent()
                const encrypt = $(obj).attr('data-encrypt')
                if (!encrypt) return true;
                createResvButtons(encrypt, resp.password, parent)
            });
        }
    });

    const authStage = $('main').attr('data-auth-stage');
    let authPassword;

    switch (authStage) {
        case 'premium':
            authPassword = sessionStorage.getItem("resv_premium_key")
            break;
        case 'member':
            authPassword = sessionStorage.getItem("resv_member_key")
            break;
    }
    if (authPassword) {
        const target = $('.reserve-buttons .button.approval')
        const parent = target.parent()
        const encrypt = target.attr('data-encrypt')
        createResvButtons(encrypt, authPassword, parent)
    }
}
export default main;